import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiService } from 'ish-core/services/api/api.service';

@Injectable({ providedIn: 'root' })
export class SalesrepService {
  constructor(private apiService: ApiService) {}

  switchSalesRepCustomer(customerID: string): Observable<string> {
    const customerInfo = { customerNo: customerID };
    return this.apiService.post<string>(`customers/-/users/-/switch`, customerInfo);
  }
}
